'use client';

import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

type WindowDimensions = {
  width: number | undefined;
  height: number | undefined;
};

const useWindowSize = (): WindowDimensions => {
  const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize(): void {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // Create a debounced version of handleResize
    const debouncedHandleResize = debounce(handleResize, 100);

    // Initial call
    handleResize();

    // Add event listener
    window.addEventListener('resize', debouncedHandleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
      debouncedHandleResize.cancel(); // Cancel any pending debounced calls
    };
  }, []); // Empty array ensures that effect is only run on mount

  return windowDimensions;
};

export default useWindowSize;
